/* eslint-disable no-underscore-dangle */
import React, { Component } from 'react';
import track from 'react-tracking';
import ReactLoading from 'react-loading';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Provider } from 'react-redux';
import store from 'shared/redux/store';
import { switchLanguage } from 'shared/redux/actions';
import SavedStateHandler from 'shared/redux/store/SavedStateHandler';
import ConnectedIntlProvider from 'shared/util/ConnectedIntlProvider';
import './App.scss';
// import { LaunchScreen } from 'pages';
import { PATH } from 'shared/constants';
import { clearIdleTimer } from 'shared/util/idleTimer';
import {
  isMobileOnly, isIOS, isMobileSafari, isIE,
  isSafari, isTablet,
} from 'react-device-detect';
import ultilitiesService from 'shared/util/ultilitiesService';
import { Button, InstallPopup } from 'components';
import api from 'shared/services/api';
import Logo from 'assets/images/logo.svg';
import Routes from './routes';
import {
  handleRefreshApp,
  handleRegisterAccount,
  detectOnVisibilityChange,
  initialTracking,
} from './App.utils';

const statusBarClass = 'status-bar--desktop';


class App extends Component {
  constructor(props) {
    super(props);
    this.timer = null;
  }

  state = {
    // loading: false,
    isDetectFinish: false,
  };

  componentDidMount() {
    // api.dropDb();
    const {
      tracking,
    } = this.props;
    const { language: { locale } } = store.getState().rootReducer;

    const urlParams = new URLSearchParams(window.location.search);
    const languageParam = urlParams.getAll('lang').toString();

    if (languageParam && locale !== languageParam.toUpperCase()) {
      store.dispatch(switchLanguage(languageParam.toUpperCase()));
    }

    /** @note disable desktop view redirection */
    // if (!isMobileOnly && !isTablet) {
    //   if (isSafari) {
    //     window.location.assign(process.env.REACT_APP_DESKTOP_URL);
    //   } else window.open(process.env.REACT_APP_DESKTOP_URL, '_self');

    //   this.setState({ isDetectFinish: true });
    // }

    // display loading screen for 2s when enter first page
    // if ([PATH.LANGUAGE, PATH.HOME].includes(window.location.pathname)) {
    //   this.showLaunchScreen();
    // }

    if (!isMobileOnly) document.body.classList.add(statusBarClass);

    // reset user after 15 mins inactive
    handleRefreshApp(this.timer);

    // create new user for the first time user visit
    handleRegisterAccount(tracking);

    // handle user drop off flow step
    detectOnVisibilityChange(tracking);

    // handle app initial Tracking
    initialTracking(tracking);
  }

  componentWillUnmount() {
    clearIdleTimer(this.timer);
    if (!isMobileOnly) document.body.classList.remove(statusBarClass);
  }

  // showLaunchScreen = () => {
  //   this.setState({
  //     loading: true,
  //   }, () => {
  //     setTimeout(() => {
  //       this.setState({
  //         loading: false,
  //       });
  //     }, 2000);
  //   });
  // };

  isIOSInstall = () => {
    // const isInStandaloneMode = () => (window.matchMedia('(display-mode: standalone)').matches) || (window.navigator.standalone) || document.referrer.includes('android-app://');

    if (isMobileOnly && isIOS && isMobileSafari && !ultilitiesService.isInStandaloneMode()) {
      return true;
    }

    return false;
  }

  render() {
    const classes = classNames({
      App: true,
      'App--desktop': !isMobileOnly,
      'App--mobileBrowser': isMobileOnly && !ultilitiesService.isInStandaloneMode(),
      'App--arabic': store.getState().rootReducer.language.locale === 'AR',
    });

    return (
      <Provider store={store}>
        <ConnectedIntlProvider>
          <>
            {this.state.isDetectFinish && <section className="page-loader"><ReactLoading height="32px" width="32px" color="#00599b" type="spin" /></section>}

            <div className={classes}>
              {/* <LaunchScreen isVisible={this.state.loading} /> */}
              {isIE && <FormattedMessage id="ieUnsupport" /> }

              {!isMobileOnly && (
              // eslint-disable-next-line react/jsx-no-target-blank
              <a href="https://www.markaz.com/" target="_blank" className="logo">
                <img src={Logo} alt="iMarkaz" />
              </a>
              )}

              <SavedStateHandler />

              <Routes />

              <div id="reset-notification">
                <FormattedMessage id="newVersion" />
                <Button
                  onButtonClick={() => {
                    localStorage.clear();
                    window.location.replace(PATH.HOME);
                  }}
                  type="button"
                  isSecondary
                  isSmall
                  value={(<FormattedMessage id="updateNow" />)}
                />
              </div>
              <InstallPopup isVisible={this.isIOSInstall()} />

            </div>
          </>
        </ConnectedIntlProvider>
      </Provider>
    );
  }
}


const AppWithTracking = track(
  {
    app: process.env.REACT_APP_TRACKING_TARGET,
  },
  {
    dispatch: (data) => {
      data.user = store.getState().rootReducer
      && store.getState().rootReducer.userInfo
      && store.getState().rootReducer.userInfo._id;
      // delete data.complex;
      api.trackingService(data);
    },
  },
)(App);

export default AppWithTracking;
